import React, { useState, useEffect, useRef } from "react";
import NavbarMob from "./NavbarMob";
import Navbar from "./Navbar";
import { useMediaQuery } from "react-responsive";
import Footer from "./Footer";
import Navbar2 from "./Navbar2";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Navbar2Mob from "./Navbar2Mob";

function EmployeeReg() {
    const [companyName, setCompanyName] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [whatsappNumber, setWhatsappNumber] = useState("");
    const [email, setEmail] = useState("");
    const [companyCategory, setCompanyCategory] = useState("");
    // const [companyDistrict, setCompanyDistrict] = useState("");
    const [address, setAddress] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [location, setLocationCategory] = useState("");

    const [categoryOptions, setCategoryOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);

    const [companyDistrict, setCompanyDistrict] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [dataLoading, setDataLoading] = useState(true);

    const navigate = useNavigate();
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    // Check if user has special power to add new districts
    const specialPower = sessionStorage.getItem("specialPower");

    // Refs for input navigation
    const companyNameRef = useRef(null);
    const mobileNumberRef = useRef(null);
    const whatsappNumberRef = useRef(null);
    const emailRef = useRef(null);
    const companyCategoryRef = useRef(null);
    const companyDistrictRef = useRef(null);
    const addressRef = useRef(null);
    const passwordRef = useRef(null);

    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const togglePasswordVisibility = () => setShowPassword(!showPassword);

    // Fetch Company Categories (from /datacompany)
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await fetch(`${apiBaseUrl}/datacompany`);
                if (res.ok) {
                    const data = await res.json();
                    const options = (data.states?.[0]?.districts || []).map((d) => ({
                        value: d,
                        label: d,
                    }));
                    setCategoryOptions(options);
                }
            } catch (err) {
                console.error("Failed to load company categories:", err);
            }
        };

        fetchCategories();
    }, [apiBaseUrl]);

    // Fetch Districts
    useEffect(() => {
        const fetchDistricts = async () => {
            try {
                setDataLoading(true);
                const res = await fetch(`${apiBaseUrl}/datadistricts`);
                if (res.ok) {
                    const data = await res.json();
                    const options = (data.states?.[0]?.districts || []).map((d) => ({
                        value: d,
                        label: d,
                    }));
                    setDistrictOptions(options);
                } else {
                    alert("Failed to load districts. Please try again later.");
                }
            } catch (err) {
                console.error("Error loading districts:", err);
                alert("Network error while loading districts.");
            } finally {
                setDataLoading(false);
            }
        };

        fetchDistricts();
    }, [apiBaseUrl]);

    // Handle creating a new district
    const handleCreateDistrict = async (inputValue) => {
        const trimmed = inputValue.trim();
        console.log("Attempting to add district:", trimmed);

        if (!trimmed) {
            alert("Please enter a valid district name");
            return;
        }

        const alreadyExists = districtOptions.some((opt) => opt.value.toLowerCase() === trimmed.toLowerCase());
        if (alreadyExists) {
            alert(`"${trimmed}" already exists!`);
            return;
        }

        try {
            console.log("Sending to backend:", { district: trimmed });

            const res = await fetch(`${apiBaseUrl}/adddistricts`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ district: trimmed }),
            });

            console.log("Response status:", res.status);
            const result = await res.json();
            console.log("Backend response:", result);

            if (!res.ok) {
                throw new Error(result.error || `HTTP ${res.status}`);
            }

            const newOption = { value: trimmed, label: trimmed };
            setDistrictOptions((prev) => [...prev, newOption]);
            setCompanyDistrict(newOption);

            // alert(`District "${trimmed}" added successfully!`);
        } catch (err) {
            console.error("Failed to add district:", err);
            alert("Failed: " + (err.message || "Check console"));
        }
    };

    // Fetch Locations (Near Big Town) - assuming same as districts or separate endpoint
    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const res = await fetch(`${apiBaseUrl}/data`);
                if (res.ok) {
                    const data = await res.json();
                    const options = (data.states?.[0]?.districts || [])
                        .filter((d) => d !== "All Kerala")
                        .map((d) => ({ value: d, label: d }));
                    setLocationOptions(options);
                }
            } catch (err) {
                console.error("Failed to load locations:", err);
            }
        };

        fetchLocations();
    }, [apiBaseUrl]);

    // Custom "Create" option for districts if not found
    // const customDistrictCreatable = (inputValue) => {
    //     const exists = districtOptions.some((opt) => opt.value.toLowerCase() === inputValue.toLowerCase());

    //     if (!exists && inputValue.trim() && specialPower === "on") {
    //         return {
    //             value: inputValue.trim(),
    //             label: `Add new district: "${inputValue.trim()}"`,
    //             __isNew__: true,
    //         };
    //     }
    //     return null;
    // };

    // const handleDistrictChange = (selected) => {
    //     if (selected && selected.__isNew__) {
    //         if (window.confirm(`Add new district "${selected.value}"?`)) {
    //             // Optional: Call backend to add immediately
    //             // Or just allow registration and add later via admin panel
    //             setCompanyDistrict(selected.value);
    //             alert(`"${selected.value}" will be saved. You can add it officially from admin panel later.`);
    //         }
    //     } else {
    //         setCompanyDistrict(selected ? selected.value : "");
    //     }
    // };

    const handleKeyDown = (e, nextRef) => {
        if (e.key === "Enter") {
            e.preventDefault();
            nextRef?.current?.focus?.();
        }
    };

    const handleSubmit = async () => {
        const missing = [];
        if (!companyName) missing.push("Company Name");
        if (!mobileNumber) missing.push("Manager Number");
        if (!whatsappNumber) missing.push("Office Number");
        if (!companyCategory) missing.push("Company Category");
        if (!companyDistrict || !companyDistrict.value) missing.push("Company District");
        if (!location) missing.push("Near Big Town");
        if (!address) missing.push("Address");
        if (!password) missing.push("Password");

        if (missing.length > 0) {
            alert(`Please fill in: ${missing.join(", ")}`);
            return;
        }

        if (!/^[0-9]{10}$/.test(mobileNumber) || !/^[0-9]{10}$/.test(whatsappNumber)) {
            alert("Mobile and Office numbers must be exactly 10 digits.");
            return;
        }

        setIsLoading(true);

        try {
            // Block check
            const blockedRes = await fetch(`${apiBaseUrl}/getBlockedProfiles`);
            const blocked = await blockedRes.json();
            const isBlocked = blocked.some((p) => p.ProfileType === "employee" && p.MobileNumber === mobileNumber);
            if (isBlocked) {
                alert("This mobile number is blocked.");
                setIsLoading(false);
                return;
            }

            // Duplicate check
            const checkRes = await fetch(`${apiBaseUrl}/checkEmployeeMobile?mobileNumber=${mobileNumber}`);
            const checkData = await checkRes.json();
            if (checkData.exists) {
                alert("This mobile number is already registered. Please login.");
                setIsLoading(false);
                return;
            }

            const districtValue = companyDistrict.value;

            // Submit registration
            const payload = {
                companyName,
                mobileNumber,
                whatsappNumber,
                email,
                companyCategory,
                companyDistrict: districtValue,
                address,
                password,
                location,
            };

            const res = await fetch(`${apiBaseUrl}/registerEmployee`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const result = await res.json();

            if (res.ok) {
                alert("Registration successful!");
                navigate("/login");
            } else {
                alert(result.message || "Registration failed.");
            }
        } catch (err) {
            alert("Network error. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const customStyles = {
        control: (base) => ({
            ...base,
            height: "43px",
            border: "2px solid #D7D7D7",
            borderRadius: "5px",
            boxShadow: "none",
            "&:hover": { borderColor: "#D7D7D7" },
        }),
    };

    return (
        <div className="flex flex-col min-h-screen">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="md:flex hidden">
                <Navbar2 />
            </div>
            <div className="md:hidden flex flex-col">
                <Navbar2Mob />
            </div>

            <div className="flex justify-center items-center bg-black py-12">
                <div className="lg:w-[80%] w-[90%] bg-white flex flex-col items-center gap-12 py-12 lg:rounded-[20px] rounded-[5px]">
                    <h1 className="text-xl font-bold font-display">Employer Register</h1>

                    {dataLoading && <p className="text-gray-600">Loading districts and categories...</p>}

                    <div className="grid lg:grid-cols-3 grid-cols-1 gap-5 lg:px-12 px-3 w-full">
                        {/* Company Name */}
                        <div className="flex flex-col gap-3">
                            <label className="text-base font-medium">Company Name</label>
                            <input
                                ref={companyNameRef}
                                type="text"
                                placeholder="Enter Company Name"
                                value={companyName}
                                onChange={(e) => setCompanyName(e.target.value)}
                                className="h-[43px] border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                onKeyDown={(e) => handleKeyDown(e, mobileNumberRef)}
                            />
                        </div>

                        {/* Manager Number */}
                        <div className="flex flex-col gap-3">
                            <label className="text-base font-medium">Manager Number</label>
                            <input
                                ref={mobileNumberRef}
                                type="number"
                                placeholder="Enter Manager No"
                                value={mobileNumber}
                                onChange={(e) => setMobileNumber(e.target.value.slice(0, 10))}
                                className="h-[43px] border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                onKeyDown={(e) => handleKeyDown(e, whatsappNumberRef)}
                            />
                        </div>

                        {/* Office Number */}
                        <div className="flex flex-col gap-3">
                            <label className="text-base font-medium">Office Number</label>
                            <input
                                ref={whatsappNumberRef}
                                type="number"
                                placeholder="Enter Office No"
                                value={whatsappNumber}
                                onChange={(e) => setWhatsappNumber(e.target.value.slice(0, 10))}
                                className="h-[43px] border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                onKeyDown={(e) => handleKeyDown(e, emailRef)}
                            />
                        </div>

                        {/* Email */}
                        <div className="flex flex-col gap-3">
                            <label className="text-base font-medium">Email (Optional)</label>
                            <input
                                ref={emailRef}
                                type="text"
                                placeholder="Enter Email Address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="h-[43px] border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                onKeyDown={(e) => handleKeyDown(e, companyCategoryRef)}
                            />
                        </div>

                        {/* Company Category */}
                        <div className="flex flex-col gap-3">
                            <label className="text-base font-medium">Company Category</label>
                            <Select
                                options={categoryOptions}
                                onChange={(opt) => setCompanyCategory(opt ? opt.value : "")}
                                placeholder="Select Category"
                                isClearable
                                value={categoryOptions.find((o) => o.value === companyCategory)}
                                styles={customStyles}
                            />
                        </div>

                        {/* Company District - With "Add New" option */}
                        <div className="flex flex-col gap-3">
                            <label className="text-base font-medium">Company District</label>
                            <CreatableSelect
                                isClearable
                                isDisabled={isLoading}
                                options={districtOptions}
                                onChange={(newValue) => setCompanyDistrict(newValue)} // newValue is object or null
                                onCreateOption={handleCreateDistrict}
                                // onCreateOption={specialPower === "on" ? handleCreateDistrict : null} // Only allow create if admin
                                placeholder="Type or select district"
                                value={companyDistrict}
                                styles={customStyles}
                                formatCreateLabel={(inputValue) => `Add new district: "${inputValue}"`}
                                noOptionsMessage={() => "Type to add a new district"}
                                createOptionPosition="first"
                            />
                        </div>

                        {/* Near Big Town */}
                        <div className="flex flex-col gap-3">
                            <label className="text-base font-medium">Near Big Town</label>
                            <Select
                                options={locationOptions}
                                onChange={(opt) => setLocationCategory(opt ? opt.value : "")}
                                placeholder="Select Location"
                                isClearable
                                value={locationOptions.find((o) => o.value === location)}
                                styles={customStyles}
                            />
                        </div>

                        {/* Address */}
                        <div className="flex flex-col gap-3">
                            <label className="text-base font-medium">Full Address</label>
                            <input
                                ref={addressRef}
                                type="text"
                                placeholder="Company Address"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                className="h-[43px] border-2 border-[#D7D7D7] rounded-[5px] px-4"
                                onKeyDown={(e) => handleKeyDown(e, passwordRef)}
                            />
                        </div>

                        {/* Password */}
                        <div className="flex flex-col gap-3">
                            <label className="text-base font-medium">Create Password</label>
                            <div className="relative">
                                <input
                                    ref={passwordRef}
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Create Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="h-[43px] w-full border-2 border-[#D7D7D7] rounded-[5px] px-4 pr-12"
                                />
                                <button
                                    type="button"
                                    onClick={togglePasswordVisibility}
                                    className="absolute right-3 top-3 text-gray-500"
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col gap-5 w-full px-12 items-center">
                        <button
                            onClick={handleSubmit}
                            disabled={isLoading || dataLoading}
                            className="h-[56px] lg:w-[25%] w-[50%] bg-[#E22E37] rounded-[20px] text-white text-lg font-bold hover:bg-black disabled:opacity-70 disabled:cursor-not-allowed transition"
                        >
                            {isLoading ? "Registering..." : "Register"}
                        </button>

                        <p className="text-base font-medium">
                            Already Registered?{" "}
                            <span
                                onClick={() => navigate("/login")}
                                className="text-[#E22E37] font-bold cursor-pointer hover:text-black"
                            >
                                Login
                            </span>
                        </p>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default EmployeeReg;
